import {Injectable} from '@angular/core';
import {BaseService} from '../../../core/abstracts/base-service.abstract';
import {Creatable, ReadableAll} from '../../../core/interfaces/base-service.interfaces';
import {AvailableColumnResponse} from '../model/available-columns.respose';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ReportRequest} from '../model/report-request.model';
import {ReportResponse} from '../model/report-response.model';

@Injectable({providedIn: 'root'})
export class ReportService extends BaseService implements ReadableAll<AvailableColumnResponse>, Creatable<ReportRequest, ReportResponse> {
  protected readonly endpoint: string = 'excel';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  public getAll(): Observable<AvailableColumnResponse[]> {
    return this.get<AvailableColumnResponse[]>('');
  }

  public create(payload: ReportRequest): Observable<ReportResponse> {
    return this.post<ReportResponse>('/export', payload);
  }
}
